import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-body-2 text-medium-emphasis mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-2 ml-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_code_text = _resolveComponent("ontos-code-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      _createVNode(_component_ontos_code_text, {
        text: _ctx.explain || _ctx.$tt('access.explain')
      }, null, 8, ["text"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinds, (kind) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: kind }, [
        (_ctx.value[kind] === undefined)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_btn, {
                variant: "text",
                class: _normalizeClass(["d-flex", {'mb-2': !_ctx.blocked[kind]}]),
                disabled: !!_ctx.blocked[kind],
                "prepend-icon": _ctx.icons[kind],
                onClick: ($event: any) => (_ctx.change(kind, ''))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tt(_ctx.labels[kind])), 1)
                ]),
                _: 2
              }, 1032, ["class", "disabled", "prepend-icon", "onClick"]),
              (_ctx.blocked[kind])
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      start: ""
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-lock", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(_ctx.blocked[kind]), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              dense: "",
              align: "start",
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "10",
                  md: "11"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ontos_formula_input, {
                      ref_for: true,
                      ref: kind,
                      class: "required",
                      label: _ctx.$tt(_ctx.labels[kind]),
                      access: _ctx.draft ? undefined : kind,
                      "field-access": _ctx.draft ? kind : undefined,
                      draft: _ctx.draft || {},
                      current: _ctx.current,
                      value: _ctx.value[kind],
                      example: _ctx.examples[kind],
                      "result-label": _ctx.resultLabel,
                      "system-alias": _ctx.workspace.alias,
                      idea: _ctx.idea,
                      "choice-domains": _ctx.workspace.domains,
                      onInput: ($event: any) => (_ctx.change(kind, $event)),
                      onValidity: ($event: any) => (_ctx.validity(kind, $event))
                    }, null, 8, ["label", "access", "field-access", "draft", "current", "value", "example", "result-label", "system-alias", "idea", "choice-domains", "onInput", "onValidity"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, {
                  cols: "2",
                  md: "1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      size: "small",
                      title: _ctx.$tt('remove'),
                      onClick: ($event: any) => (_ctx.remove(kind))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-delete-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title", "onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
      ], 64))
    }), 128))
  ]))
}